<template>
  <div class="bpjs-page">
        <PageHeader icon="fas fa-shield-alt">
      <template #title>
        Pengaturan Kredensial Satu Sehat
      </template>
      <template #subtitle>
        Kredensial disimpan terenkripsi dan tidak pernah ditampilkan kembali.
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-lg-12">
        <Form
          :form="form"
          :route="'satu-sehat-settings/1'"
          purpose="table"
        />
      </div>
    </div>
  </div>
</template>
      
<script>
import Card from "@/view/content/Card.vue";
import Form from "@/component/satu-sehat/AccessTokenForm.vue";
import module from "@/core/modules/CrudModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      form: {
        client_id: "",
        client_secret: "",
        organization_id: "",
      },
      dataLoaded: false,
    };
  },

  components: {
    Card,
    Form,
  },

  methods: {
    async get() {
      this.form = await module.get("satu-sehat-settings/1");
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        // this.$router.push("/satu-sehat-settings");
      } else {
        this.form["_method"] = "put";
        this.dataLoaded = true;
      }
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Satu Sehat" },
      { title: "Kode Akses API" },
    ]);

    this.get();
  },
};
</script>